<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'AllDicts' }" id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к справочникам
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<div class="name">
							<h3 class="title">Список доступных параметров окон:</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn">
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link :to="{ name: 'windowParamItemData', params: {id: 'new'}}"
													 class="md-primary"
													 tag="md-button">
											Добавить новый элемент
										</router-link>
									</div>
								</div>
								<md-card v-if="windowParams.length>0" class="md-card-plain">
									<md-card-content>
										<md-table class="table-shopping" v-model="windowParams">
											<md-table-row slot="md-table-row" slot-scope="{ item }">
												<md-table-cell md-label="Название">
													<router-link
															:to="{ name: 'windowParamItemData', params: { id:item.id } }">
														{{ item.typeName }}
													</router-link>
												</md-table-cell>
												<md-table-cell md-label="Описание">
													<router-link
															:to="{ name: 'windowParamItemData', params: { id:item.id } }">
														{{ item.typeDesc }}
													</router-link>
												</md-table-cell>

												<md-table-cell>
													<router-link
															:to="{ name: 'windowParamItemData', params: {id: item.id, action: 'delete'} }"
															event="" @click.native.prevent="confirmDelete({ name: 'windowParamItemData', params: {id: item.id, action: 'delete'} })"
													>
														<md-icon>delete</md-icon>
													</router-link>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</md-card-content>
								</md-card>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { getItem } from '@/utils/dict-api'

    export default {
        bodyClass: 'model-list',
        data () {
            return {
                windowParams: [],
                windowTechParams: [],
            }
        },
        methods: {
            setItems () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('windowparamtype').then(result => {
                        this.windowParams = result
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            this.setItems()
        },
    }
</script>
<style lang="scss" scoped type="text/scss">
	.savebtn {
		margin-right: 0;
		padding-right: 5px;
	}

</style>
